import * as React from "react";
import * as moment from "moment";
import { quotationFormStyles } from "./QuotationForm.styles";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";
import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { WithStyles } from "@material-ui/core";
import { Form } from "../../types/Form";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import InputDate from "../InputDate/InputDate";
import InputText from "../InputText/InputText";
import { Quotation } from "../../types/Quotation";
import { User } from "../../models/User.model";

interface QuotationFormAdvisorProps extends WithStyles<typeof quotationFormStyles> {
    productName: string;
    advisor: User;
    quotation: Quotation;
    onChange(validityDate: string);
}

type QuotationFormAdvisorState = {
    form: Form<any>;
};

class QuotationFormAdvisor extends React.Component<QuotationFormAdvisorProps, QuotationFormAdvisorState> {

    private formBuilder = null;

    /**
     * 
     */
    public componentWillMount() {
        this.updateState(this.props);
    }

    /**
     * 
     */
    public componentWillReceiveProps(nextProps: QuotationFormAdvisorProps) {
        this.updateState(nextProps);
    }

    /**
     * 
     * @param fieldName 
     * @param value 
     * @param element 
     */
    public onChange(fieldName: string, value: any, element: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        let form = builder.exec(this.state.form);
        this.setState({form: form});
        this.props.onChange(value);
    }

    /**
     * 
     */
    public render() {
        if (!this.state) {
            return null;
        }
        const uiForm = this.formBuilder.build(this.state.form);
        return (
            <div className={this.props.classes.squareBox}>
                <Typography variant="title" gutterBottom={true} className={this.props.classes.formTitle}>1/ Cadre réservé aux conseillers</Typography>
                <Grid container={true} spacing={32}>
                    <Grid item={true} sm={4}>
                        <InputText
                            disabled={true}
                            label="Projet réalisé par"
                            value={this.props.advisor.firstname + " " + this.props.advisor.lastname}
                        />
                    </Grid>
                    <Grid item={true} sm={4}>
                        <InputText
                            disabled={true}
                            label="Proposition établie le"
                            value={moment().format("DD/MM/YYYY")}
                        />
                    </Grid>
                    <Grid item={true} sm={4}>
                        <InputText
                            disabled={true}
                            label="Entité distibutrice"
                            value={this.props.advisor.company ? this.props.advisor.company.label : ""}
                        />
                    </Grid>
                    { this.props.advisor.company.name === "ag2r" ? (
                        <Grid item={true} sm={4}>
                            <InputText
                                disabled={true}
                                label="Code vendeur"
                                value={this.props.advisor.vendorCode}
                            />
                        </Grid>
                    ) : (
                        <Grid item={true} sm={4}>
                            <InputText
                                disabled={true}
                                label="Code apporteur"
                                value={this.props.advisor.bringerCode}
                            />
                        </Grid>

                    )}
                    <Grid item={true} sm={4}>
                        <InputText
                            disabled={true}
                            label="Code agence"
                            value={this.props.advisor.agencyCode}
                        />
                    </Grid>

                    <Grid item={true} sm={4}>
                        <InputDate {...uiForm.fields.validityDate} />
                    </Grid>
                </Grid>
            </div>
        );
    }

    private updateState(props: QuotationFormAdvisorProps) {
        this.formBuilder = new UiFormBuilder<any>();

        this.formBuilder
            .addField("validityDate", {
                props: {
                    label: "Date de validité du tarif",
                    placeholder: "Saisir la date",
                    legend: "*Le tarif peut évoluer au mois anniversaire de l'assuré",
                    required: true,
                    dateProps: {
                        min: moment().format("YYYY-MM-DD"),
                        max: moment().add(1, "year").format("YYYY-MM-DD")
                    }
                }
            })
            .onChange(this.onChange.bind(this))
        ;
        this.setState({
            form: {
                fields: {},
                errors: [],
                values: {
                    validityDate: props.quotation.validityDate
                }
            }
        });
    }
}

export default QuotationFormAdvisor;



// WEBPACK FOOTER //
// ./src/components/QuotationForm/QuotationFormAdvisor.tsx